<template>
	<v-app id="inspire">
		<v-content>
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-2" >
							<img src="../assets/osbod_background_whatsapp.jpg">
							<v-toolbar color="primary" dark flat>
								<v-toolbar-title>Login OSBOD</v-toolbar-title>
								<div class="flex-grow-1"></div>
							</v-toolbar>
							<v-card-text>
								<form id="osbod-login-form" @submit.prevent="onSubmit">
									<v-text-field
										label="Gebruikersnaam (school e-mail)"
										name="Gebruikersnaam"
										v-model="form.username"
										prepend-icon="mdi-account"
										type="text"
										filled
										autocomplete="username"
									></v-text-field>

									<v-text-field
										id="password"
										label="Wachtwoord"
										name="Wachtwoord"
										v-model="form.password"
										prepend-icon="mdi-lock"
										type="password"
										filled
										autocomplete="current-password"
									></v-text-field>
								</form>
								<!--
								FUTURE: portal wachtwoord-reset aan login — uncomment dit blok + script-onderdelen hieronder gemarkeerd met "FUTURE: forgot-password"
								<v-btn text small color="primary" class="px-0 mt-1" type="button" @click="openForgotDialog">
									Wachtwoord vergeten?
								</v-btn>
								<v-dialog v-model="forgotDialog" max-width="480" persistent>
									<v-card>
										<v-card-title class="headline">Wachtwoord herstellen</v-card-title>
										<v-card-text>
											<p class="body-2">
												Vul het school e-mailadres waarmee u normaal inlogt (uw gebruikersnaam). Als dit adres bij ons bekend is, ontvangt u een nieuw wachtwoord per e-mail.
											</p>
											<v-text-field
												v-model="forgotEmail"
												label="School e-mailadres"
												type="email"
												filled
												dense
												class="mt-2"
												:disabled="forgotLoading || !!forgotMessage"
											></v-text-field>
											<v-alert v-if="forgotMessage" type="info" dense text class="mt-2">{{ forgotMessage }}</v-alert>
											<v-alert v-if="forgotError" type="error" dense text class="mt-2">{{ forgotError }}</v-alert>
										</v-card-text>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn text @click="closeForgotDialog" :disabled="forgotLoading">Sluiten</v-btn>
											<v-btn
												v-if="!forgotMessage"
												color="primary"
												depressed
												:loading="forgotLoading"
												@click="submitForgot"
											>
												Versturen
											</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
								-->
							</v-card-text>
							<v-card-actions>
								<div class="flex-grow-1"></div>
								<v-btn
									depressed
									color="secondary"
									type="submit"
									form="osbod-login-form"
								>
									Inloggen
								</v-btn>
							</v-card-actions>
						</v-card>
						<br />
						<v-alert
							:value="error"
							border="right"
							colored-border
							type="error"
							elevation="2"
							transition="scale-transition"
						>{{error_message}}</v-alert>
					</v-col>
				</v-row>
			</v-container>
		</v-content>
	</v-app>
</template>
<script>
// FUTURE: forgot-password — uncomment wanneer login-template hierboven actief is:
// import Axios from "axios";
// import { API_ROOT } from "../config";
// const ax = Axios.create({
// 	baseURL: API_ROOT["osbod_salary"],
// 	timeout: 60000
// });

export default {
	name: "login",
	data() {
		return {
			form: {
				username: "",
				password: ""
			},
			source: "",
			error_message: "",
			error: false
			// FUTURE: forgot-password — uncomment deze regels samen met template + imports + methods:
			// forgotDialog: false,
			// forgotEmail: "",
			// forgotLoading: false,
			// forgotMessage: "",
			// forgotError: ""
		};
	},
	computed: {
		user() {
			return this.$store.getters.getUser;
		},
		loggedin() {
			return this.$store.getters.getLoggedin;
		}
	},
	watch: {
		user: function() {
			var access = localStorage.getItem("access");
			console.log(access);

			if (access) {
				var u = {};
				try {
					u = JSON.parse(localStorage.getItem("user") || "{}");
				} catch (e) {
					u = this.$store.getters.getUser || {};
				}
				if (Number(u.reset_credentials) === 1) {
					this.$router.push({
						path: "/change_password"
					});
				} else {
					this.$router.push({
						path: "/main"
					});
				}
			} else {
				this.error_message = "Inloggen Mislukt!";
				this.error = true;
			}
		}
	},
	mounted() {

		// window.addEventListener("keyup", function(event) {
		// 	console.log(event);
		// });
	},
	methods: {
		// FUTURE: forgot-password — uncomment deze methods samen met template + imports + data:
		// openForgotDialog() {
		// 	this.forgotEmail = this.form.username ? String(this.form.username).trim() : "";
		// 	this.forgotMessage = "";
		// 	this.forgotError = "";
		// 	this.forgotDialog = true;
		// },
		// closeForgotDialog() {
		// 	this.forgotDialog = false;
		// 	this.forgotLoading = false;
		// 	this.forgotMessage = "";
		// 	this.forgotError = "";
		// },
		// submitForgot() {
		// 	var email = (this.forgotEmail || "").trim();
		// 	this.forgotMessage = "";
		// 	this.forgotError = "";
		// 	if (!email) {
		// 		this.forgotError = "Vul uw school e-mailadres in.";
		// 		return;
		// 	}
		// 	var self = this;
		// 	this.forgotLoading = true;
		// 	ax.post("/public/portal_forgot_password", { username: email })
		// 		.then(function(res) {
		// 			var d = res.data;
		// 			if (d && d.success === false && d.msg) {
		// 				self.forgotError = d.msg;
		// 			} else {
		// 				self.forgotMessage = (d && d.msg) ||
		// 					"Als dit e-mailadres bij ons bekend is, ontvangt u spoedig een e-mail.";
		// 			}
		// 		})
		// 		.catch(function() {
		// 			self.forgotError = "Verzoek mislukt. Probeer het later opnieuw.";
		// 		})
		// 		.finally(function() {
		// 			self.forgotLoading = false;
		// 		});
		// },
		// Recover() {
		// 	this.$router.push({ path: "/recover" });
		// },
		onSubmit() {
			console.log(this.form.username);
			console.log(this.form.password);
			console.log(this.form);

			this.$store.dispatch("login", {
				username: this.form.username,
				password: this.form.password
			});
		}
	}
};
</script>
 <style scoped>
</style>
